import React, { useState, useEffect } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import FormCheckInput from 'react-bootstrap/FormCheckInput';
import FormSelect from 'react-bootstrap/FormSelect';
import Alert from 'react-bootstrap/Alert'
import TextBoxDropdown from './TextboxDropdown';

function convertToLocalDate(dateString) {
  const date = new Date(dateString.replace(/Z/g, ''));
  const timezoneOffset = date.getTimezoneOffset() * 60000;
  const localTime = date.getTime() - timezoneOffset;

  return new Date(localTime);
}

function getTimeAgo(targetDate) {
  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - targetDate.getTime();

  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  let timeAgo;

  if (days > 0) {
    timeAgo = days + " day" + (days > 1 ? "s" : "") + " ago";
  } else if (hours > 0) {
    timeAgo = hours + " hour" + (hours > 1 ? "s" : "") + " ago";
  } else if (minutes > 0) {
    timeAgo = minutes + " minute" + (minutes > 1 ? "s" : "") + " ago";
  } else {
    timeAgo = seconds + " second" + (seconds > 1 ? "s" : "") + " ago";
  }

  return timeAgo;
}

function AssessmentsTable({onLoaded}) {
    const [data, setData] = useState([]);
    const [searches, setSearches] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [activeSearch, setActiveSearch] = useState(null);
    const [activeThreatLevel, setActiveThreatLevel] = useState(null);
    const [fromDate, setFromDate] = useState(new Date().valueOf() - 10800000);
    const [toDate, setToDate] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedRowText, setSelectedRowText] = useState('');
    const [selectedRows, setSelectedRows] = useState([]);
    const [showSearchFilter, setShowTrustedFilter] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showRowsModal, setShowRowsModal] = useState(false);
    const [showRegenerateAlert, setShowRegenerateAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);

    const fetchData = async (forceRefresh = false) => {
      if (fetching) return;
      setFetching(true);
      const cacheBuster = new Date().getTime();
      const isLocalMode = (window.global_LocalMode !== undefined && window.global_LocalMode === true);
      const refreshSuffix = forceRefresh ? '&refresh=true' : '';
      var url = '/Assessments';

      if (isLocalMode) {
        url = url + '.json';
      } else {
        url = url + '?k=signalTriage2025&_=' + cacheBuster + refreshSuffix;
      }

      const response = await fetch(url);
      const activeAssessments = await response.json();
      
      var searchesUrl = '/Searches';

      if (isLocalMode) {
        searchesUrl = searchesUrl + '.json';
      } else {
        searchesUrl = searchesUrl + '?k=signalTriage2025&_=' + cacheBuster + refreshSuffix;
      }
            
      const searchesResponse = await fetch(searchesUrl);          

      if (searchesResponse.ok) {
        const activeSearches = await searchesResponse.json();   
        activeSearches.sort((a,b) => { 
          if (a.Name.toLowerCase() < b.Name.toLowerCase()) { return -1; } 
          else if (a.Name.toLowerCase() > b.Name.toLowerCase()) { return 1; } 
          return 0;
        });
        setSearches(activeSearches);        
      }

      setSelectedRows([]);
      setData(activeAssessments);
      setFetching(false);
      onLoaded();
    };

    useEffect(() => {   
        const refresh = new URLSearchParams(window.location.search).has('refresh');

        if (refresh) {
          const url = new URL(window.location);
          const params = new URLSearchParams(url.search);
          params.delete('refresh');
          window.history.replaceState({}, '', `${url.pathname}?${params}`);
          fetchData(true);          
        } else {
          fetchData();
        }
    }, []);

    const handleRowsClick = async () => {
      resetNotificationState();
      setSelectedRow(selectedRows[0]);
      setShowRowsModal(true);
    }

    const handleRegenerateClick = async () => {
      resetNotificationState();
      const ids = selectedRows.map(r => r.PostId);
      
      try
      {
        const url = '/Assessment/Regenerate?ids=' + ids;
        const response = await fetch(url, { method: 'POST' });

        if (response.status === 200) {
          setShowRegenerateAlert(true);

          setTimeout(() => {
            fetchData(true);
          }, 3000);
        } else {
          setShowErrorAlert(true);
        } 
      }
      catch (e)
      {
        setShowErrorAlert(true);
      }
    }

    const resetNotificationState = () => {
      setShowErrorAlert(false);
      setShowRegenerateAlert(false);
    }

    const handleCheckInput = async (el, row) => {
      if (el.target.checked) {
        setSelectedRows([...selectedRows, row]);
      } else {
        setSelectedRows(selectedRows.filter((item) => item !== row));
      }
    }

    const handleSearchChange = async (el) => {
      if (el.target.value === 'None') setActiveSearch(null);
      else setActiveSearch(el.target.value);
      setSelectedRows([]);
    }

    const handleThreatLevelChange = async (el) => {
      if (el.target.value === 'All') setActiveThreatLevel(null);
      else setActiveThreatLevel(el.target.value);
      setSelectedRows([]);
    }

    const handleSearchFilterCheck = async (el) => {
      setShowTrustedFilter(!showSearchFilter);
      setSelectedRows([]);
    }

    const getDateValue = (e) => {
      var defaultValue = new Date();
      var dateValue = defaultValue;
      
      switch (e)
      {
        case '1 hour ago':
          dateValue = dateValue - 3600000;
          break;
        case '2 hours ago':
          dateValue = dateValue - 7200000;
          break;
        case '3 hours ago':
          dateValue = dateValue - 10800000;
          break;
        case '6 hours ago':
          dateValue = dateValue - 21600000;
          break;
        case '12 hours ago':
          dateValue = dateValue - 43200000;
          break;
        case '24 hours ago':
          dateValue = dateValue - 86400000;
          break;
        case '2 days ago':
          dateValue = dateValue - 172800000;
          break;
        case '3 days ago':
          dateValue = dateValue - 259200000;
          break;
        case '7 days ago':
          dateValue = dateValue - 604800000;
          break;
        default:
          return new Date(defaultValue);
      }

      return new Date(dateValue);
    }

    const handleFromDateChange = async (el) => {
      if (el === 'Earliest') setFromDate(null);
      else 
      {
        var dateValue = getDateValue(el);
        if (dateValue.toString() !== 'Invalid Date')
        {
          setFromDate(dateValue);
        }
      }
      setSelectedRows([]);
    }

    const handleToDateChange = async (el) => {
      if (el === 'Now') setToDate(null);
      else 
      {
        var dateValue = getDateValue(el);
        if (dateValue.toString() !== 'Invalid Date')
        {
          setToDate(dateValue);
        }
      }
      setSelectedRows([]);
    }
    
    const hasSelectedRows = () => {
      return selectedRows.length > 0;
    }

    const hasSingleSelection = () => {
      return selectedRows.length === 1;
    }

    const getDataFilteredBySearch = (filteredData) => {
      if (activeSearch === null) return filteredData;
      return filteredData.filter((item) => item.SearchId === activeSearch);
    }

    const getDataFilteredByThreatLevel = (filteredData) => {
      if (activeThreatLevel === null) return filteredData;
      return filteredData.filter((item) => item.Severity === activeThreatLevel);
    }

    const getDataFilteredByFromDate = (filteredData) => {
      if (fromDate === null) return filteredData;
      return filteredData.filter((item) => { var comparison = new Date(item.Timestamp); return comparison >= fromDate });
    }

    const getDataFilteredByToDate = (filteredData) => {
      if (toDate === null) return filteredData;
      return filteredData.filter((item) => { var comparison = new Date(item.Timestamp); return comparison <= toDate });
    }

    const getFilteredData = () => {
      var filteredData = data;
      
      filteredData = getDataFilteredBySearch(filteredData);
      filteredData = getDataFilteredByThreatLevel(filteredData);
      filteredData = getDataFilteredByFromDate(filteredData);
      filteredData = getDataFilteredByToDate(filteredData);

      return filteredData;      
    }

    const getSearchName = (searchId) => {
      if (searchId === null) return 'Unknown';
      const search = searches.find((s) => s.SearchId === searchId);
      if (search) return search.Name;
      return 'Unknown';
    }

    const handleDeselectClick = () => {
      setSelectedRows([]);
      
      var inputs = document.getElementsByTagName('input');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].type === 'checkbox') {
          inputs[i].checked = false;
        }
      }
    }
    
    const handleClose = () => setShowModal(false);
    const handleRowsClose = () => setShowRowsModal(false);

    return (
        <div className="container">  
            <div>
              {showRegenerateAlert && 
                <Alert variant="success">
                    Assessment(s) queued for regeneration.
                </Alert>
              }              
              {showErrorAlert && 
                <Alert variant="danger">
                    An error occurred, please try again.
                </Alert>
              }
            </div>        
            <div>
                <div style={{float: 'left', marginLeft: '10px', marginRight: '10px'}}>From</div>         
                <TextBoxDropdown defaultValue="3 hours ago" onValueChanged={(e) => handleFromDateChange(e)} />
                <div style={{float: 'left', marginLeft: '10px', marginRight: '10px'}}>to</div>
                <TextBoxDropdown defaultValue="Now" onValueChanged={(e) => handleToDateChange(e)}/>                
                <div style={{float: 'left', marginLeft: '40px', marginRight: '10px'}}>                  
                  <FormCheckInput checked={showSearchFilter} onChange={(el) => handleSearchFilterCheck(el)}></FormCheckInput>
                  &nbsp;
                  Filter
                </div>  
                <div style={{float: 'right'}}>                
                <Button className={hasSingleSelection() ? '' : 'disabled'} style={{fontSize: '16px'}} variant={hasSingleSelection() ? 'success' : 'light'} onClick={() => handleRowsClick()}>
                Details
                </Button>
                &nbsp;                               
                <Button className={hasSelectedRows() ? '' : 'disabled'} style={{fontSize: '16px'}} variant={hasSelectedRows() ? 'warning' : 'light'} onClick={() => handleRegenerateClick()}>
                Regenerate
                </Button>                
                </div>                        
            </div>
            <div className="clearfix"></div>
            {showSearchFilter && (            
            <div>
              <div style={{float: 'left', marginRight: '10px'}}>Search:</div>
              <div style={{float: 'left'}}>
                <FormSelect onChange={(el) => handleSearchChange(el)}>
                  <option>None</option>
                  {searches.map((source) => (
                    <option value={source.SearchId}>{source.Name} ({source.SearchId})</option>
                  ))}
                </FormSelect>
              </div>
              <div style={{float: 'left', marginRight: '10px', marginLeft: '20px'}}>Threat Level:</div>
              <div style={{float: 'left'}}>
                <FormSelect onChange={(el) => handleThreatLevelChange(el)}>
                  <option>All</option>
                  <option value="HIGH">HIGH</option>
                  <option value="MODERATE">MODERATE</option>
                  <option value="LOW">LOW</option>
                </FormSelect>
              </div>
              <div style={{float: 'left', marginRight: '10px'}}><br/><br/></div>              
            </div>            
            )}            
            <div className="clearfix"></div>
            <div style={{float: 'left'}}>
                <Button className={hasSelectedRows() ? '' : 'disabled'} style={{float: 'left', fontSize: '14px'}} variant={hasSelectedRows() ? 'info' : 'light'} onClick={() => handleDeselectClick()}>
                  Deselect all
                </Button>
                <div style={{float: 'left', marginLeft: '20px', marginTop: '6px', color: '#666666'}}>Showing {getFilteredData().length} of {data.length}</div>  
            </div>            
            <div className="clearfix"></div>
            <ListGroup style={{maxHeight: '75vh', overflowY: 'auto', marginTop: '10px'}}>
                {getFilteredData().map((row, index) => (
                    <ListGroup.Item key={index}>
                        <div style={{float: 'left'}}>
                          <FormCheckInput onClick={(el) => handleCheckInput(el, row)}></FormCheckInput>
                        </div>
                        <div style={{float: 'left', marginLeft: '10px'}}>
                        <span className='badge text-bg-primary' style={{width: '150px'}}>{row.Severity}</span>                        
                        </div>
                        <div style={{float: 'left', width: '10px'}}>&nbsp;</div>
                        <div className="ms-2 me-auto" style={{float: 'left', textAlign: 'left', overflow: 'wrap'}}> 
                          <h5 style={{fontSize: '16px'}} className="mb-1">{row.Title}</h5>
                          <div style={{float: 'left'}}><small>Posted {getTimeAgo(convertToLocalDate(row.Timestamp))} in {getSearchName(row.SearchId)}</small></div>
                          {row.Languages && (                        
                              <div style={{float: 'left', marginLeft: '4px'}}>
                              {row.Languages.map((l) => (
                                <img alt={l} width='16px' height='12px' src={getLanguageFlagUrl(l)} style={{marginRight: '4px'}}></img>                                
                              ))} 
                              </div>
                          )}
                        </div>
                        {row && row.Classification == "NONE" && hasSingleSelection() && selectedRows[0] == row && classificationData.length > 0 && (
                          <div style={{float: 'right', width: '300px'}}>
                            <div style={{float: 'left', marginRight: '10px'}}>
                              <FormSelect value={selectedClassificationForNoneRow} style={{width: '200px'}} onChange={(e) => setSelectedClassificationForNoneRow(e.target.value)}>
                                {classificationData && classificationData.map((classification) => (
                                  <option key={classification} value={classification}>{classification}</option>
                                ))}                            
                              </FormSelect>
                            </div>
                            <div>
                              <Button style={{fontSize: '16px'}} variant={'warning'} onClick={() => handleReclassifyClick()}>
                              Classify
                              </Button>
                            </div>
                          </div>
                        )}                        
                    </ListGroup.Item>
                ))}
            </ListGroup>            

            <Modal show={showModal} onHide={handleClose} className="modal-xl">
                <Modal.Header closeButton>
                    <Modal.Title>Briefing</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRowText && (
                        <div>
                            <p>{selectedRowText.split('\n').map((line, index) => (
                                <span key={index}>
                                    {line}
                                    <br />
                                </span>))}</p>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            
            <Modal show={showRowsModal} onHide={handleRowsClose} className="modal-xl">
                <Modal.Header closeButton>
                    <Modal.Title>{selectedRow && (
                        <span>{selectedRow.Title}</span>
                    )}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {selectedRow && (
                        <div><p>{selectedRow.Assessment}</p></div>
                    )}
                    <div>
                    {selectedRow && (
                        <span><b>Post Id:</b> {selectedRow.PostId}</span>
                    )}
                    <br/>
                    {selectedRow && (
                        <span><b>Search Id:</b> {selectedRow.SearchId}</span>
                    )}
                    <br/>
                    {selectedRow && (
                        <span><b>Organisation Id:</b> {selectedRow.OrganisationId}</span>
                    )}
                    <br/>
                    {selectedRow && (
                        <span><b>Timestamp:</b> {getTimeAgo(convertToLocalDate(selectedRow.Timestamp))} ({convertToLocalDate(selectedRow.Timestamp).toUTCString()})</span>
                    )}
                    </div>
                    <br/>
                    <div>
                      <table>
                      <thead>
                        <tr style={{fontSize: '0.8em', borderBottom: 'solid 1px #cccccc'}}>
                          <th style={{width: '100%'}}>Original Content</th>                            
                        </tr>
                      </thead>
                      <tbody>                    
                      {selectedRow && selectedRow.OriginalContent.map((row, index) => (
                        <tr key={index} style={{fontSize: '0.8em', borderBottom: 'solid 1px #cccccc'}}>
                          <td>{row}</td>                            
                        </tr>      
                      ))}
                      </tbody>
                      </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleRowsClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>            
        </div>
    );
}

export default AssessmentsTable;
